import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ModalCalculateComponent } from 'src/app/modules/report-management/modal-calculate/modal-calculate.component';

@Component({
  selector: 'lifedi-report-spider-template',
  templateUrl: './report-spider-template.component.html',
  styleUrls: ['./report-spider-template.component.scss']
})
export class ReportSpiderTemplateComponent implements OnInit {

  @Input() reportForm: FormGroup;
  @Input() reportType: string;
  @Input() reportID: string;
  @Input() measureID: string;
  @Input() isEdit: boolean;
  @Input() isPaid: boolean;

  color;
  saveStatus: number = 0;

  constructor(
    private fb: FormBuilder,
    public matDialog: MatDialog,
  ) { }

  ngOnInit(): void {
    // console.log(this.reportForm);
    if (!this.isEdit || this.reportForm.value.PSY_BLOCKS.length === 0) { this.addGroup(); }
  }

  addGroup() {
    this.saveStatus = 1;
    (<FormArray>this.reportForm.get("PSY_BLOCKS")).push(this.fb.group({
      PSY_GROUP_NAME: ['', Validators.required],
      PSY_GROUP_COLOR: ['', Validators.required],
      PSY_DATA: this.fb.array([]),
    }))
  }

  addPsychoGroup(form) {
    form.push(this.fb.group({
      PSY_NAME: ['', Validators.required],
      DETAIL_PSY: ['', Validators.required],
      CAL: ['', Validators.required],
    }));
    // console.log(this.reportForm);
  }

  removeGroup(index) {
    (<FormArray>this.reportForm.get("PSY_BLOCKS")).removeAt(index);
  }

  removePsychoGroup(form, index) {
    form.removeAt(index);
  }

  openCalculateModal(form, i, j, edit) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      reportId: this.reportID,
      measureId: this.measureID,
      isEdit: edit,
      title: 'คำนวณ',
      calData: this.reportForm.value.PSY_BLOCKS[i].PSY_DATA[j].CAL,
      typeReport: this.reportType,
      actionBtnText: 'บันทึก',
    }

    const modal = this.matDialog.open(ModalCalculateComponent, dialogConfig);
    modal.afterClosed().pipe(
      map(res => {
        if (res.status) {
          // console.log(res.data);

          ((form as FormArray).at(j) as FormGroup).get('CAL').patchValue(res.data);
          ((form as FormArray).at(j) as FormGroup).get('CAL').updateValueAndValidity();
          // console.log(this.reportForm);

        }
      }),
      catchError((err) => {
        // console.log(err);
        alert(err.error.message)
        return of(null);
      }),
    ).subscribe();

  }

}
